module.exports = __webpack_public_path__ + "img/db54a9f732eaa64d9160b346154d6ffe.png";